const elements = {
  navigation: document.body.querySelector('.js-navigation'),
  wrapper: document.body.querySelector('.js-navigation__wrapper'),
  trigger: document.body.querySelector('.js-navigation-trigger'),
  buttons: [...document.body.querySelectorAll('.js-navigation__button')],
  dropdowns: [...document.body.querySelectorAll('.js-navigation__dropdown')],
};

let currentWindowSize;
const desktopWidth = 1024;
const active = 'is-active';

function getSiblings(elem) {
  const siblings = [];
  let sibling = elem.parentNode.firstChild;
  for (; sibling; sibling = sibling.nextSibling) {
    if (sibling.nodeType === 1 && sibling !== elem) {
      siblings.push(sibling);
    }
  }
  return siblings;
}

function toggleVisibility() {
  const targetDiv = document.getElementById(this.getAttribute('aria-controls'));
  const buttonIcon = this.querySelector('.c-navigation__button-icon');
  const buttonState = this.getAttribute('aria-expanded');
  const buttonStateLabel = this.querySelector('.js-navigation__button-state');
  const parent = this.closest('li');
  const prop = 'hidden';
  currentWindowSize = window.innerWidth;

  // De-activate siblings (needed for keyboard nav on desktop)
  if (parent && (currentWindowSize > desktopWidth)) {
    const siblings = [...getSiblings(parent)];
    siblings.forEach(sibling => sibling.classList.remove('is-active'));
  }

  if (parent) { // If there's a parent li activate it
    parent.classList.toggle(active);
  }
  this.classList.toggle(active); // Set the toggle to active
  targetDiv.classList.toggle(active); // Set the target active

  // If mobile then toggle visibility
  if (currentWindowSize < desktopWidth) {
    targetDiv[prop] = !targetDiv[prop];
  }

  // Toggle the aria-expanded state
  if (buttonState === 'false') {
    this.setAttribute('aria-expanded', 'true');
  } else {
    this.setAttribute('aria-expanded', 'false');
  }

  // Toggle the button icon
  if (buttonIcon) {
    buttonStateLabel.innerHTML = this.classList.contains(active) ? 'Close' : 'Open';
  }
}

function resetNavigation() {
  currentWindowSize = window.innerWidth;
  const activeDivs = [...elements.navigation.querySelectorAll('.is-active')];
  const ariaExpanded = [...elements.navigation.querySelectorAll('[aria-expanded="true"]')];
  const buttonStateLabels = [...elements.navigation.querySelectorAll('.js-navigation__button-state')];

  // Reset icons and labels
  buttonStateLabels.forEach(buttonStateLabel => buttonStateLabel.innerHTML = 'Open'); // eslint-disable-line

  // Remove active classes
  activeDivs.forEach(el => el.classList.remove(active));

  // Set aria expanded to false
  ariaExpanded.forEach(el => el.setAttribute('aria-expanded', 'false'));

  // Hide dropdowns if mobile
  if (currentWindowSize < desktopWidth) {
    elements.dropdowns.forEach((el) => {
      el.setAttribute('hidden', '');
    });
  }
}

function windowResize() {
  if (currentWindowSize === window.innerWidth) {
    return;
  }
  // Remove active states and decorate aria
  currentWindowSize = window.innerWidth;
  resetNavigation();

  if (currentWindowSize < desktopWidth) {
    elements.wrapper.setAttribute('hidden', '');
    elements.dropdowns.forEach(el => el.setAttribute('hidden', ''));
  } else {
    elements.wrapper.removeAttribute('hidden');
    elements.dropdowns.forEach(el => el.removeAttribute('hidden'));
  }
}

function init() {
  currentWindowSize = window.innerWidth;

  // Don't bother if there's no navigatgion...
  if (!elements.navigation) {
    return;
  }

  // If mobile...
  if (currentWindowSize < desktopWidth) {
    elements.wrapper.setAttribute('hidden', 'true');

    // Hide dropdown
    elements.dropdowns.forEach(el => el.setAttribute('hidden', ''));
  }

  // Add navigation toggle
  if ((elements.navigation) && (elements.trigger)) {
    elements.trigger.addEventListener('click', toggleVisibility);
    window.addEventListener('resize', windowResize);
  }

  // Setup dropdown button event handlers
  if (elements.buttons.length) {
    elements.buttons.forEach(el => el.addEventListener('click', toggleVisibility));
  }

  /* Catching Clicks
  / Stopping propogation isn't a good idea so we do this to detect
  / page clicks and close the menu, see the link below for details.
  / https://css-tricks.com/dangers-stopping-event-propagation/
  */

  document.addEventListener('click', (event) => {
    const target = event.target.closest('.js-navigation, .js-navigation-trigger');
    if (!target) {
      resetNavigation();
    }
  });
}

export default init;



// WEBPACK FOOTER //
// ./src/components/components/ccg/navigation/mando-ui.navigation.js